<template>
<div class="about">


  <section id="people">

    <InfoPanel
      img="portland1.jpg">
      <h3>Christian Parker</h3>
      <h5>Quantitative Ecologist and Developer</h5>
      <p>Christian is a talented researcher and consultant with experience across the academic, public and private sectors in statistical analysis, advanced database design, and full stack programming. He specializes in the development and evaluation of environmental predictive models and uncertainty. Through teaching, various ecological research labs, and consulting, Christian has over 20 years of experience building databases and online tools to support data collection and analysis. Christian is passionate about using these skills to make data accessible for his clients to help solve complex environmental problems.</p>
    </InfoPanel>

    <InfoPanel
      img="oakland1.jpg">
      <h3>Adam Fallon</h3>
      <h5>Technical Consultant</h5>
      <p>Adam is a veteran consultant with international experience in application security, web application development, small business advisement, and project management who was a student of physics and astronomy in a previous life. Having worked with small organizations to Fortune 500 companies, he is adept at understanding and supporting a wide variety of organizational needs. Based out of Northern California, Adam's interests are in helping companies successfully utilize their data to support meaningful research and initiatives.</p>
    </InfoPanel>

  </section>



  <ContactPanel>
    <h3>Think we can help you?</h3>
    <p>
      If any of our services look like something you need just let us know.
    </p>
  </ContactPanel>

</div>
</template>

<script>
import ScrollIntoView from '@/mixins/ScrollIntoView';
import InfoPanel from '@/components/sections/InfoPanel';
import LinkPanel from '@/components/sections/LinkPanel';
import CardPanel from '@/components/sections/CardPanel';
import JumboPanel from '@/components/sections/JumboPanel';
import ContactPanel from '@/components/sections/ContactPanel';
import DataSharing from '../assets/img/data-sharing.svg'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'About',
  mixins: [
    ScrollIntoView,
  ],
  components: {
    CardPanel,
    InfoPanel,
    JumboPanel,
    ContactPanel,
    LinkPanel,
    DataSharing,
  },
  created(){
    this.pageView('about');
  },
  computed: {
      ...mapState([
        'services',
        'problems',
        'messages',
        'projects',
        'articles',
        'links',
      ]),
    ...mapGetters([
      'activeNews',
      'activeProjects'
    ]),
    servicesNewsProjects(){
      return this.services
        .map( s => {
          // all the articles that are
          var news = this.activeNews
              .filter( n => n.tags.some( t => s.tags.includes(t)))
              .slice(0, 3)
              .map( n => ({ uid: n.uid, label: n.label }))
          var projects = this.activeProjects
              .filter( p => p.tags.some( t => s.tags.includes(t)))
              .slice(0, 3)
              .map( p => ({ uid: p.uid, label: p.label }))
          return { ...s, news, projects }
        })
    }
  },
  methods: {
    ...mapActions([
      'pageView'
    ]),
    url(file){
      return `url(/img/${file})`;
    }
  }
}
</script>


<style lang="scss" scoped>
@import '~@/styles/variables';
.about {

  #services {
    margin: 0 auto;
    max-width: 70rem;
  }
}
</style>
